import React, { memo, useEffect, useState, useCallback } from 'react';
import './index.less';
import HeadBtn from '../components/headBtn';
import StorageFn from '@/utils/electronStorage';
import { lmessage } from '@/views/login/message';
import { useHistory } from 'react-router-dom';

function LoginUpgrade() {
  let [versionTitle, setVersion] = useState<string>('');
  let [updateMessage, setMessage] = useState<string[]>([]);
  let [process, setProcess] = useState<number>(0);
  let [isUpdate, setIsUpdate] = useState<boolean>(false);
  let [downUrl, setDownUrl] = useState<string>('');
  let [isPause, setIsPause] = useState<boolean>(false);
  let [offline, setOffline] = useState<boolean>(false);
  const history: any = useHistory();
  const isCore = history.location?.state?.isCore;
  const upgradeRes = history.location?.state?.res;

  let updateOfflineStatus = useCallback(() => {
    StorageFn.electronUpdate(downUrl, null, 'pause', isCore);
    setIsPause(true);
    setOffline(true);
  }, [downUrl, isCore]);

  function updateOnlineStatus() {
    setTimeout(() => {
      // 盒子对网络有延迟，后续改成盒子通知
      setOffline(false);
    }, 3000);
  }
  useEffect(() => {
    window.addEventListener('offline', updateOfflineStatus);
    window.addEventListener('online', updateOnlineStatus);
    const unListen = () => {
      window.removeEventListener('offline', updateOfflineStatus);
      window.removeEventListener('online', updateOnlineStatus);
    };
    return () => {
      unListen();
    };
  }, [updateOfflineStatus]);
  let percentTimer: any;
  let steps = 0.1;
  function updateIn(url?: string) {
    setIsUpdate(true);
    StorageFn.electronUpdate(
      url ? url : downUrl,
      (data: any) => {
        if (!isCore) {
          let percent = Number(data.percent);
          if (percent > 0.9) {
            percent = 0.9;
            if (!percentTimer) {
              percentTimer = setInterval(() => {
                steps = steps / 2;
                setProcess((percent += steps));
                console.log(percent);
                if (percent >= 0.9999) {
                  clearInterval(percentTimer);
                }
              }, 2000);
            }
            return;
          }
        }
        setProcess(data.percent);
      },
      '',
      isCore
    );
  }
  function reUpdate() {
    if (offline) {
      return lmessage.error('请检查您的网络');
    } else {
      StorageFn.electronUpdate(
        downUrl,
        (data: any) => {
          setProcess(data.percent);
        },
        'resume',
        isCore
      );
      setIsPause(false);
    }
  }
  function ignore() {
    localStorage.setItem(
      'warningUpload',
      JSON.stringify({
        channel_id: upgradeRes?.new_info.channel_no,
        download_url: upgradeRes?.new_info.app_download_url,
        show: true,
        status: 2,
        type: isCore ? 2 : 1,
        update_notice: upgradeRes?.new_info.app_update_notice,
        version: upgradeRes?.new_info.app_version
      })
    );
    history.goBack();
  }

  useEffect(() => {
    if (!isCore) {
      if (upgradeRes.cur_info && (upgradeRes.cur_info.app_status === 1 || upgradeRes.cur_info.app_status === 2)) {
        setVersion(upgradeRes?.new_info.app_version);
        setMessage(upgradeRes?.new_info.app_update_notice?.replaceAll('\n', '||').split('||'));
        setDownUrl(upgradeRes?.new_info.app_download_url);
        if (upgradeRes.cur_info) {
          if (upgradeRes?.cur_info.app_status === 1) {
            updateIn(upgradeRes?.new_info.app_download_url);
          }
        } else if (upgradeRes.new_info) {
          if (upgradeRes?.new_info.app_status === 1) {
            updateIn(upgradeRes?.new_info.app_download_url);
          }
        }
      }
    } else {
      if (upgradeRes && (upgradeRes.new_info.app_status === 1 || upgradeRes.new_info.app_status === 2)) {
        setMessage(upgradeRes?.new_info.app_update_notice?.replaceAll('\n', '||').split('||'));
        setDownUrl(upgradeRes?.new_info.app_download_url);
        if (upgradeRes.new_info.app_status === 1) {
          updateIn(upgradeRes?.new_info.app_download_url);
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="main_position_box">
      <HeadBtn headBtnType={1}></HeadBtn>
      <div className="upgrade_content">
        <div className="upgrade_title">{versionTitle ? `V_${versionTitle}` : ''}更新内容</div>
        <div className="upgrade_info_box">
          {updateMessage?.map((item, index) => {
            return (
              <div key={index} className="upgrade_info_item">
                {item}
              </div>
            );
          })}
        </div>
        <div className="upgrade_btns" style={{ display: isUpdate ? 'none' : 'flex' }}>
          <div className="cancel_upgrade" onClick={ignore}>
            暂不更新
          </div>
          <div className="confim_upgrade" onClick={() => updateIn()}>
            立即更新
          </div>
        </div>
        <div className="upgrade_working" style={{ display: !isUpdate ? 'none' : 'block' }}>
          <div className="working_info">
            <span>
              {isPause ? '更新已暂停' : '正在更新中'} {(process * 100).toFixed(2)}%
            </span>
            <div className="working_resume" style={{ display: isPause ? 'block' : 'none' }} onClick={reUpdate}>
              继续更新
            </div>
          </div>
          <div className="working_processs">
            <div className="process" style={{ width: process * 280 + 'px' }}></div>
          </div>
          <div className="working_tip">
            若升级卡顿，请先关闭其他软件。详情
            <span
              onClick={() => {
                (window as any).raw.openExternalBrower({ url: 'https://docs.qq.com/doc/DTFFvYVJ3TGpTaHdz' });
              }}
            >
              请点击
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
export default memo(LoginUpgrade);
